import React, { createContext, PropsWithChildren, useContext, useMemo, ReactElement } from 'react';

export interface WatchListTableContextType {
  isNameBeingChanged: boolean;
}

interface WatchListTableContextProviderProps extends WatchListTableContextType, PropsWithChildren {}

const WatchlistTableContext = createContext<WatchListTableContextType | null>(null);

// there is an ag-grid bug https://github.com/ag-grid/ag-grid/issues/5301 about noRowsOverlayComponent not re-rendered on noRowsOverlayComponentParams changed, therefore we use context
const WatchListTableContextProvider = ({
  children,
  isNameBeingChanged,
}: WatchListTableContextProviderProps): ReactElement => {
  const value: WatchListTableContextType = useMemo(
    () => ({
      isNameBeingChanged,
    }),
    [isNameBeingChanged]
  );

  return <WatchlistTableContext.Provider value={value}>{children}</WatchlistTableContext.Provider>;
};

const useWatchListTableContext = (): WatchListTableContextType => {
  const context = useContext(WatchlistTableContext);
  if (!context) {
    throw new Error('Hook must be used within the provider.');
  }

  return context;
};

export { WatchListTableContextProvider, useWatchListTableContext };
